import { get } from "lodash-es";
import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Toast } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useRouterParams } from "../../../abstracts";
import {
  FileTypeWithExt,
  LoaderWrapper,
  ManagePayrollTabLayout,
  ProgressFileStatus,
} from "../../../components";
import ErrorDuplicates from "./ErrorDuplicate";
import PayrollProgressBar from "../../../components/PayrollProgressBar";
import { getFileInfo, managePayrollStore } from "../../../contexts";
import {
  finalSubmit,
  finalSubmitAndFunding,
  getCorrectAcceptDuplicateEmployee,
  getCountriesList,
  getPayrollFrequencies,
  getRevalidateFile,
  getStates,
} from "../../../services";
import {
  FILE_UPLOAD_STATUS,
  getParamsFromQueryString,
  MANAGE_PAYROLL_ROUTES,
  getAdvancedPathWithParam,
  getPathWithParam,
  ROUTES,
} from "../../../utils";
import PayrollFunding from "./PayrollFunding/PayrollFunding";
import ErrorFoundRecords from "./ErrorFoundRecords";
import FileInformation from "./FileInformation";
import PayrollFundingDetails from "./PayrollFunding/FundingSliders/PayrollFundingDetails";
import PayrollSubmission from "./PayrollSubmission";
import DataMismatchErrors from "./DataMismatchErrors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { useRef } from "react";
import { withAppLayout } from "../../../hoc";
import tenantConfig from "../../../mocks/tenantOne.json";
import permissions from "../../../mocks/menuPermissions.json";
import { camelCase, isEmpty } from "lodash";
import authService from "../../../components/api-authorization/AuthorizeService";
const PayrollFileStatusConatiner = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(managePayrollStore);
  const search = useLocation().search;
  const amount = new URLSearchParams(search).get("amount");
  const [isSubmit, setIsSubmit] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [payrollSubmit, setPayrollSubmit] = useState(false);
  const [SubmisonDisable, setSubmisonDisable] = useState(true);
  const [AwaitingFunding, setAwaitingFunding] = useState(true);
  const [ecrSubmit, setEcrSubmit] = useState(false);
  const [acceptWarning, setAcceptWarning] = useState(false);
  const [isRecordDeleted, setIsRecordDeleted] = useState(false);
  const [errorType, setErrorType] = useState(null);
  const { payrollId, employeeId } = useRouterParams();
  const tab = getParamsFromQueryString("tab");
  const [keyValue, setKeyValue] = useState(parseInt(tab));
  const [recordsListType, setRecordsListType] = useState("");
  const payrollDetails = get(state, "api.data", {});
  const [isLoading, setIsLoading] = useState(false);
  const [empId, setEmpId] = useState(0);
  const [payrollCensusPage, setPayrollCensusPage] = useState(false);
  const [defaultTab, setDefaultTab] = useState("census");
  const [toggle, setToggle] = useState(true);
  const [frequencyList, setFrequencyList] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [warnings, setWarnings] = useState(null);
  const [errors, setErrorRecords] = useState(0);
  const censusAndErrorPage = (records, id) => {
    setEmpId(id);
    setPayrollCensusPage(true);
    history.push({
      pathname: `${MANAGE_PAYROLL_ROUTES.CENSUS_AND_PAYROLL}/${payrollId}/${id}`,
    });
    if (payrollDetails.fileType === 2) setDefaultTab("payroll");
  };
  const toggleFileStatus = () => {
    setToggle(!toggle);
  };
  const toggleAcceptWarning = () => {
    setAcceptWarning(!acceptWarning);
  };
  const tabChange = (key) => {
    setKeyValue(key);
  };
  const payrollnavigate = () => {
    // setKeyValue(keyValue - 1);
    history.push(
      getAdvancedPathWithParam({
        path: ROUTES.PAYROLL,
        //  pathParam: [],
      })
    );
  };
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const isFirstRun = useRef(true);
  const errorSubmissionPage = () => {
    if (keyValue == 1) {
      tabChange(2);
      setKeyValue(2);
      history.push(`${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}/?tab=2`);
    } else if (keyValue == 2) {
      setIsSubmit(!isSubmit);
      if (!isLoading) {
        if (
          payrollDetails.totalRecords !== 0 &&
          payrollDetails.totalErrors === 0 &&
          payrollDetails.totalWarnings === 0
        ) {
          history.push(
            getAdvancedPathWithParam({
              path: `${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}/?tab=3`,
            })
          );
          setKeyValue(3);
        }
      }
    } else if (keyValue == 3) {
      setIsLoading(true);
      if (tenantConfig["payrollSubmissionSubMenu"].includes("funding")) {
        finalSubmit(payrollId, payrollDetails.fileType)
          .then((response) => {
            if (response) {
              if (payrollDetails.fileType === 1) {
                history.push(`${MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING}`);
              } else {
                setPayrollSubmit(true);
                setIsLoading(false);
                tabChange(4);
                history.push(
                  `${ROUTES.PAYROLL_FILE_STATUS}/${payrollId}/?tab=4`
                );
              }
            }
          })
          .catch((error) => {
            setIsLoading(false);
          });
      } else {
        finalSubmitAndFunding(payrollId, payrollDetails.fileType)
          .then((response) => {
            if (response) {
              history.push(`${MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING}`);
            }
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    }
  };
  const revalidateId = (i) => {
    setIsLoading(true);
    getRevalidateFile(i)
      .then((response) => {
        if (response) {
          setIsLoading(false);
          history.push({
            pathname: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (payrollDetails) {
      setIsLoading(true);
      if (isFirstRun.current) {
        isFirstRun.current = false;
        return;
      }
      getPayrollFrequencies(payrollDetails.companyId).then((response) => {
        setFrequencyList(response);
        setIsLoading(false);
      });
      getStates().then((response) => {
        setStates(response);
        setIsLoading(false);
      });
      getCountriesList().then((response) => {
        setCountries(response);
        setIsLoading(false);
      });
    }
  }, [payrollDetails]);
  useEffect(() => {
    if (payrollDetails.totalDuplicateRecords > 0) {
      setErrorType(2);
    } else if (
      payrollDetails.fileStatus ===
      FILE_UPLOAD_STATUS.StructuralValidationFailed
    ) {
      setErrorType(1);
    } else {
      setErrorType(3);
    }
    setSubmisonDisable(
      get(payrollDetails, "fileStatus") === FILE_UPLOAD_STATUS.PendingSubmission
    );
    setAwaitingFunding(
      get(payrollDetails, "fileStatus") ===
        FILE_UPLOAD_STATUS.AwaitingFunding ||
        get(payrollDetails, "fileStatus") ===
          FILE_UPLOAD_STATUS.AwaitingFundConfirmation
    );
  }, [
    payrollId,
    payrollSubmit,
    ecrSubmit,
    acceptWarning,
    payrollDetails,
    isRecordDeleted,
  ]);
  useEffect(() => {
    setIsLoading(true);
    dispatch(getFileInfo(payrollId, dispatch, state, setIsLoading));
  }, [
    payrollId,
    payrollSubmit,
    ecrSubmit,
    acceptWarning,
    isRecordDeleted,
    isSubmit,
  ]);
  const SaveEmployeeId = (i) => {
    setIsLoading(true);
    getCorrectAcceptDuplicateEmployee(i)
      .then((response) => {
        if (response) {
          setIsLoading(false);
          history.push({
            pathname: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
          });
          // setShowToast(true);
          window.location.reload();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const isAllowedUpdate = () => {
    return (
      permissions &&
      permissions[roleName]["payrollSubMenu"]["uploadFile"].includes("U")
    );
  };

  const buttons = [
    {
      label: keyValue == 3 ? "Submit" : "Next",
      variant: "primary",
      type: "button",
      onClick: errorSubmissionPage,
    },
  ];
  const getFileName = (key) => {
    let name;
    switch (key) {
      case 1:
        name = "File Information";
        break;
      case 2:
        name = "Validation & Errors";
        break;
      case 3:
        name = "File Submission";
        break;
      case 4:
        name = "Payroll Funding";
        break;

      default:
        break;
    }
    return name;
  };
  const [selectedTabIndex, setTabIndex] = useState("all_records");

  return (
    <div
      isLoading={isLoading}
      className="w-100"
      style={{ height: "92vh", overflowY: "scroll", overflowX: "hidden" }}
    >
      <Row>
        <Col md={3} style={{ paddingRight: "9px" }}>
          <PayrollProgressBar
            payrollDetails={payrollDetails}
            setKeyValue={setKeyValue}
            keyValue={keyValue}
            fileType={payrollDetails.fileType}
            payrollProcess={tab}
          />
        </Col>
        <Col className="mt-3" md={9}>
          <ManagePayrollTabLayout
            isLoading={isLoading}
            label={getFileName(keyValue)}
            step={keyValue}
            buttons={
              !(warnings?.length > 0 || errors > 0) &&
              (payrollDetails.fileStatus == "FileUploadInProgress" ||
                payrollDetails.fileStatus == "ErrorCorrectionRequired" ||
                payrollDetails.fileStatus == "PendingSubmission") &&
              keyValue !== 4 &&
              errorType !== 1 &&
              isAllowedUpdate()
                ? buttons
                : null
            }
          >
            {keyValue == 1 ? (
              <FileInformation
                payrollDetails={payrollDetails}
                errorType={errorType}
                setKeyValue={setKeyValue}
                selectedTabIndex={selectedTabIndex}
                setTabIndex={setTabIndex}
              />
            ) : keyValue == 2 ? (
              errorType === 1 ? (
                <DataMismatchErrors data={payrollDetails} />
              ) : errorType === 3 ? (
                <ErrorFoundRecords
                  selectedTabIndex={selectedTabIndex}
                  setTabIndex={setTabIndex}
                  setIsSubmit={setIsSubmit}
                  setEcrSubmit={setEcrSubmit}
                  info={payrollDetails}
                  setIsLoading={setIsLoading}
                  isLoading={isLoading}
                  onClick={censusAndErrorPage}
                  revalidateIds={revalidateId}
                  fileType={payrollDetails.fileType}
                  fileId={payrollId}
                  toggleFileStatus={toggleFileStatus}
                  toggleAcceptWarning={toggleAcceptWarning}
                  setRecordsListType={setRecordsListType}
                  tabChange={tabChange}
                  isRecordDeleted={isRecordDeleted}
                  setIsRecordDeleted={setIsRecordDeleted}
                  menu={"payroll"}
                  subMenu={"uploadFile"}
                  frequencyList={frequencyList}
                  states={states}
                  countries={countries}
                  warnings={warnings}
                  setWarnings={setWarnings}
                  errors={errors}
                  setErrorRecords={setErrorRecords}
                  // fileName={get(payrollDetails, "fileName", {})}
                />
              ) : errorType === 2 ? (
                <ErrorDuplicates
                  onClick={(i) => {
                    SaveEmployeeId(i);
                  }}
                  info={payrollDetails}
                  fileId={payrollId}
                  datas={payrollDetails}
                  toggleFileStatus={toggleFileStatus}
                />
              ) : null
            ) : keyValue == 3 ? (
              // (payrollDetails.fileStatus ===
              //   FILE_UPLOAD_STATUS.PendingSubmission ||
              //   payrollDetails.fileStatus ===
              //     FILE_UPLOAD_STATUS.AwaitingFunding ||
              //   payrollDetails.fileStatus ===
              //     FILE_UPLOAD_STATUS.AwaitingFundConfirmation) && (
              <PayrollSubmission
                fileId={payrollId}
                totalFunding={amount}
                data={payrollDetails}
                setIsLoading={setIsLoading}
                setPayrollSubmit={setPayrollSubmit}
                enableSubmit={SubmisonDisable}
                menu={"payroll"}
                subMenu={"uploadFile"}
                tabChange={tabChange}
                isRecordDeleted={isRecordDeleted}
              />
            ) : // )
            keyValue == 4 ? (
              // (payrollDetails.fileStatus ===
              //   FILE_UPLOAD_STATUS.AwaitingFunding ||
              //   payrollDetails.fileStatus ===
              //     FILE_UPLOAD_STATUS.AwaitingFundConfirmation) && (
              <PayrollFunding data={payrollDetails} tab={tab} />
            ) : // )
            null}
          </ManagePayrollTabLayout>
        </Col>
        <Col></Col>
      </Row>
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        style={{
          position: "fixed",
          top: "10rem",
          right: "2rem",
          zIndex: "100",
        }}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <div className="d-flex justify-content-between">
            <div className="toast-text">
              <FontAwesomeIcon
                icon={faCheckCircle}
                color="#3bb54a"
                className="mr-2"
              />
              Data Saved Successfully{" "}
            </div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                color="#000"
                onClick={() => setShowToast(false)}
                className="pointer ml-2"
              />
            </div>
          </div>
        </Toast.Body>
      </Toast>
    </div>
  );
};
export default PayrollFileStatusConatiner;
